import { mutatorAction } from 'satcheljs';
import getDefaultCLPLabel from 'owa-mail-clp/lib/utils/getDefaultCLPLabel';
import ItemCLPInfo from 'owa-mail-store/lib/store/schema/ItemCLPInfo';
import CLPViewState from '../store/schema/CLPViewState';

export default mutatorAction(
    'updateCLPViewState',
    (clpViewState: CLPViewState, itemCLPInfo: ItemCLPInfo) => {
        if (clpViewState && itemCLPInfo) {
            const { selectedLabel, nonTenantLabelString } = itemCLPInfo;
            if (selectedLabel) {
                clpViewState.selectedCLPLabel = selectedLabel;
                clpViewState.originalCLPLabel = selectedLabel;
            }
            if (!clpViewState.selectedCLPLabel) {
                clpViewState.selectedCLPLabel = getDefaultCLPLabel();
            }
            clpViewState.nonTenantLabelString = nonTenantLabelString;
        }
    }
);
